export var Activity;
(function (Activity) {
    Activity[Activity["APP_INITIALIZED"] = 0] = "APP_INITIALIZED";
    Activity[Activity["POINTCLOUD_LOADED"] = 1] = "POINTCLOUD_LOADED";
    Activity[Activity["DESIGNDATA_LOADED"] = 2] = "DESIGNDATA_LOADED";
    Activity[Activity["FLATGROUNDDATA_LOADED"] = 3] = "FLATGROUNDDATA_LOADED";
    Activity[Activity["ROAD_LOADED"] = 4] = "ROAD_LOADED";
    Activity[Activity["ROAD_CREATED"] = 5] = "ROAD_CREATED";
    Activity[Activity["ROAD_CANCELLED"] = 6] = "ROAD_CANCELLED";
    Activity[Activity["ROAD_EDIT_STARTED"] = 7] = "ROAD_EDIT_STARTED";
    Activity[Activity["ROAD_EDIT_ENDED"] = 8] = "ROAD_EDIT_ENDED";
    Activity[Activity["ROAD_CONTROLPOINT_UPDATED"] = 9] = "ROAD_CONTROLPOINT_UPDATED";
    Activity[Activity["ROAD_SLOPEBREAK_UPDATED"] = 10] = "ROAD_SLOPEBREAK_UPDATED";
    Activity[Activity["ROAD_GEOMETRYSHAPE_UPDATED"] = 11] = "ROAD_GEOMETRYSHAPE_UPDATED";
    Activity[Activity["ROAD_SETTINGS_UPDATED"] = 12] = "ROAD_SETTINGS_UPDATED";
    Activity[Activity["ROAD_2D_DATA_CALCULATED"] = 13] = "ROAD_2D_DATA_CALCULATED";
    Activity[Activity["ROAD_SECTION_PLANE_UPDATED"] = 14] = "ROAD_SECTION_PLANE_UPDATED";
    Activity[Activity["TRENCH_LOADED"] = 15] = "TRENCH_LOADED";
    Activity[Activity["TRENCH_CREATED"] = 16] = "TRENCH_CREATED";
    Activity[Activity["TRENCH_CANCELLED"] = 17] = "TRENCH_CANCELLED";
    Activity[Activity["TRENCH_EDIT_STARTED"] = 18] = "TRENCH_EDIT_STARTED";
    Activity[Activity["TRENCH_EDIT_ENDED"] = 19] = "TRENCH_EDIT_ENDED";
    Activity[Activity["TRENCH_CONTROLPOINT_UPDATED"] = 20] = "TRENCH_CONTROLPOINT_UPDATED";
    Activity[Activity["TRENCH_SLOPEBREAK_UPDATED"] = 21] = "TRENCH_SLOPEBREAK_UPDATED";
    Activity[Activity["TRENCH_GEOMETRYSHAPE_UPDATED"] = 22] = "TRENCH_GEOMETRYSHAPE_UPDATED";
    Activity[Activity["TRENCH_SETTINGS_UPDATED"] = 23] = "TRENCH_SETTINGS_UPDATED";
    Activity[Activity["TRENCH_2D_DATA_CALCULATED"] = 24] = "TRENCH_2D_DATA_CALCULATED";
    Activity[Activity["TRENCH_SECTION_PLANE_UPDATED"] = 25] = "TRENCH_SECTION_PLANE_UPDATED";
    Activity[Activity["POINT_CLOUD_VISIBILITY_UPDATE"] = 26] = "POINT_CLOUD_VISIBILITY_UPDATE";
    Activity[Activity["DESIGNDATA_VISIBILITY_UPDATE"] = 27] = "DESIGNDATA_VISIBILITY_UPDATE";
    Activity[Activity["FLATGROUNDDATA_VISIBILITY_UPDATE"] = 28] = "FLATGROUNDDATA_VISIBILITY_UPDATE";
    Activity[Activity["REFERENCE_TOPOLOGY_LOADED"] = 29] = "REFERENCE_TOPOLOGY_LOADED";
    Activity[Activity["REFERENCE_TOPOLOGY_VISIBILITY_UPDATE"] = 30] = "REFERENCE_TOPOLOGY_VISIBILITY_UPDATE";
    Activity[Activity["REFERENCE_TOPOLOGY_EDITED"] = 31] = "REFERENCE_TOPOLOGY_EDITED";
})(Activity || (Activity = {}));
export class ActivityLogger {
    logs;
    static instance;
    constructor() {
        this.logs = [];
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ActivityLogger();
        }
        return this.instance;
    }
    addLog(activity) {
        const previous = this.logs.pop();
        if (previous) {
            const current = { activity, previous, next: undefined };
            previous.next = current;
            this.logs.push(previous, current);
        }
        else {
            this.logs.push({ activity, previous: undefined, next: undefined });
        }
    }
    static get latest() {
        return this.getInstance().logs[this.getInstance().logs.length - 1];
    }
    static log(activity) {
        this.getInstance().addLog(activity);
    }
}
//# sourceMappingURL=activity-logger.js.map